function SelectRectangleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      fill="currentcolor"
    >
      <rect fill="none" height="24" width="24" />
      <path d="M18.75 3c1.186 0 2.165.93 2.245 2.097L21 5.25V11a1 1 0 01-2 0V6.167a1.17 1.17 0 00-1.04-1.16L17.833 5H6.167a1.17 1.17 0 00-1.16 1.04L5 6.167v11.666a1.17 1.17 0 001.04 1.16l.127.007H11a1 1 0 010 2H5.25a2.257 2.257 0 01-2.245-2.097L3 18.75V5.25c0-1.186.93-2.165 2.097-2.245L5.25 3h13.5z" />
      <path d="M14.33 10h-.03a1.34 1.34 0 00-1.3 1.34v10c.02.6.39 1.092.926 1.27l.153.05h.251l.14-.007a1.35 1.35 0 00.94-.533l2.304-3.45h3.956a1.323 1.323 0 001.26-.884 1.33 1.33 0 00-.434-1.494l-7.323-5.986A1.312 1.312 0 0014.33 10z" />
    </svg>
  );
}

export default SelectRectangleIcon;
